import React from 'react';
import loginBgImage from '../../../assets/images/login_bg.jpg';

interface IFullProps {
    children?: React.ReactNode;
    hasImg?: boolean;
    hasWindowHeight?: boolean;
}

export const Full: React.FC<IFullProps> = ({ children, hasImg = false, hasWindowHeight = false }) => {
    return (
        <div className="full-container" style={{ backgroundImage: `url(${hasImg && loginBgImage})`, height: `${hasWindowHeight ? '100vh' : '100%'}` }}>
            {children}
        </div>
    );
};
